export default "__VITE_ASSET__C9NTiaYf__"